/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{RemoveScrollSideCar as r}from"./SideEffect.js";import{effectCar as e}from"./medium.js";import{exportSidecar as s}from"../../../use-sidecar/dist/es2015/exports.js";var m=s(e,r);export{m as default};
//# sourceMappingURL=sidecar.js.map
